<template>
  <div class="confirmation-wrapper">
    <div class="confirmation-box">
      <h1>{{ translations.stripe_status.title }}</h1>
      
      <div v-if="loading" class="pending">
        {{ translations.stripe_status.checking }}
      </div>
      <div v-else>
        <div v-if="status === 'paid'">
          <p class="success">
            {{ translations.stripe_status.success }}
          </p>
          <p class="order-number" v-if="orderNumber">
            {{ translations.stripe_status.order_number }} <strong>{{ orderNumber }}</strong>
          </p>
        </div>
        <div v-else-if="status === 'unpaid' || status === 'failed' || status === 'expired'">
          <p class="failed">
            {{ translations.stripe_status.failed }}
          </p>
          <p class="pending">
            {{ translations.stripe_status.contact }}:
            <a href="mailto:biuro@birdstool.pl">biuro@birdstool.pl</a>
          </p>
        </div>
        <div v-else>
          <p class="pending">
            {{ translations.stripe_status.pending }}
          </p>
        </div>
      </div>

      <router-link to="/" class="btn-return">
        🏠 {{ translations.stripe_status.back_home }}
      </router-link>
    </div>
  </div>
</template>

<script>
import { translations } from '@/locales/lang'
import axios from "axios";
export default {
  name: "AppStripeStatus",
  data() {
    return {
      status: "",
      loading: true,
      interval: null,
      tryCount: 0,
      orderNumber: null
    };
  },
  computed: {
    translations() {
      return translations.value
    }
  },
  mounted() {
    this.orderNumber = this.$route.query.order || localStorage.getItem("order_number") || null;
    this.interval = setInterval(this.checkStripeStatus, 4000);
    this.checkStripeStatus();
  },
  beforeUnmount() {
    clearInterval(this.interval);
  },
  methods: {
    async checkStripeStatus() {
      const sessionId = this.$route.query.session_id;
      if (!sessionId) return;
      this.tryCount += 1;
      try {
        const response = await axios.get(
          `https://birdstool.pl/api/v1/stripe/status/?session_id=${sessionId}`
        );
        this.status = response.data.status;
        if (["paid", "unpaid", "expired"].includes(this.status) || this.tryCount > 20) {
          clearInterval(this.interval);
          this.loading = false;
          if (this.status === "paid") {
            localStorage.removeItem("order_number");
            localStorage.removeItem("cart");
            window.dispatchEvent(new Event('cartUpdated'));
          }
        }
      } catch (error) {
        this.status = "failed";
        clearInterval(this.interval);
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.confirmation-wrapper {
  background: #f2f4f7;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  box-sizing: border-box;
  overflow: hidden; /* ✅ zapobiega przesuwaniu */
  position: relative;
}

.confirmation-box {
  background: #fff;
  padding: 40px;
  border-radius: 16px;
  max-width: 600px;
  width: 100%;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
  text-align: center;
}

.confirmation-box h1 {
  font-size: 2rem;
  margin-bottom: 10px;
}

.confirmation-box p {
  font-size: 1.1rem;
  margin: 10px 0;
}

.order-number {
  font-size: 1.2rem;
  font-weight: 600;
  color: #111;
  margin-top: 20px;
}

.success {
  color: green;
  font-weight: bold;
  font-size: 20px;
}

.failed {
  color: red;
  font-weight: bold;
  font-size: 20px;
}

.pending {
  color: orange;
  font-weight: bold;
  font-size: 18px;
}

.btn-return {
  display: inline-block;
  margin-top: 32px;
  padding: 14px 28px;
  background: #111;
  color: #fff;
  font-weight: 600;
  border-radius: 10px;
  text-decoration: none;
  transition: background 0.2s ease;
}

.btn-return:hover {
  background: #000;
}

body, html {
  margin: 0;
  padding: 0;
  height: 100%;
  overflow-x: hidden;
}
</style>
